export const Permissions = {
  Timesheets: {
    List: 'nina.timesheets.list',
    Update: 'nina.timesheets.update',
    SendToAnael: 'nina.timesheets.send-to-anael',
    ListAllOfManagementCenter:
      'nina.timesheets.can_see_all_of_my_management_center',
    LaunchMatchingContract: 'nina.timesheets.can_launch_matching_contract',
  },
  HistoryActions: {
    List: 'nina.history-actions.list',
  },
  AdvanceRequest: {
    List: 'nina.dac.advance-request.list',
    Create: 'nina.dac.advance-request.create',
    SuperAdmin: 'nina.dac.super-user',
  },
  AdvancePeriods: {
    Create: 'nina.dac.advance-period.create',
    Delete: 'nina.dac.advance-period.delete',
  },
  Delegation: {
    ListAll: 'nina.delegations.list.all',
    ListCG: 'nina.delegations.list.cg',
  },
};
